import {useQuery} from 'react-query';
import {getThisYearCultivations} from 'services/farm/advertisement/add/thisYearCultivation';

const useGetThisYearCultivation = () => {
  const {data, isLoading} = useQuery(
    ['this-year-cultivations'],
    getThisYearCultivations,
  );
  return {cultivations : data , cultivationsisLoading : isLoading};
};

export default useGetThisYearCultivation;
